import React, {useState} from "react";
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography, useTheme } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { ExpandMore } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { IClaimInsertionForm } from "../../models/models";
import { FormAutocomplete, FormDateTimePicker, FormTextField } from "../../common/form-fields-wrappers";

const ClaimInsertionRaInfo = () => {
    const {t} = useTranslation(['network', 'translation']);
    const theme = useTheme();

    const claimInsertionForm = useFormContext<IClaimInsertionForm>();

    const [accordion, setAccordion] = useState(true);

    const handleAccordionOnChange = (e: React.SyntheticEvent, expanded: boolean) => {
        e.stopPropagation();

        setAccordion(expanded);
    }

    return (
        <Accordion expanded={accordion} onChange={(e, expanded) => handleAccordionOnChange(e, expanded)}>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant={"h6"}>
                    {t("claimInsertion.claimInsertionRaInfo.accordion.title")}
                </Typography>
            </AccordionSummary>

            <AccordionDetails>
                <Grid container columnSpacing={2}>
                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IClaimInsertionForm>
                            name='claimInsertionRaInfo.raNumber'
                            control={claimInsertionForm.control}
                            label={t("claimInsertion.claimInsertionRaInfo.form.label.raNumber")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormAutocomplete<IClaimInsertionForm>
                            name='claimInsertionRaInfo.dmsIdentificationCode'
                            control={claimInsertionForm.control}
                            label={t("claimInsertion.claimInsertionRaInfo.form.label.DMSIdentification")}
                            fullWidth
                            options={[]}
                            isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
                            getOptionLabel={(opt: any) => opt?.description}
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormDateTimePicker<IClaimInsertionForm>
                            name="claimInsertionRaInfo.pickUpDate"
                            control={claimInsertionForm.control}
                            label={t("claimInsertion.claimInsertionRaInfo.form.label.pickUpDate")}
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IClaimInsertionForm>
                            name='claimInsertionRaInfo.renewalsAndSubstitutions'
                            control={claimInsertionForm.control}
                            label={t("claimInsertion.claimInsertionRaInfo.form.label.renewalsAndSubstitutions")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IClaimInsertionForm>
                            name='claimInsertionRaInfo.invoiceNumber'
                            control={claimInsertionForm.control}
                            label={t("claimInsertion.claimInsertionRaInfo.form.label.nrInvoice")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormAutocomplete<IClaimInsertionForm>
                            name='claimInsertionRaInfo.invoiceIdentificationCode'
                            control={claimInsertionForm.control}
                            label={t("claimInsertion.claimInsertionRaInfo.form.label.invoiceDmsCode")}
                            fullWidth
                            options={[]}
                            isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
                            getOptionLabel={(opt: any) => opt?.description}
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormDateTimePicker<IClaimInsertionForm>
                            name="claimInsertionRaInfo.invoiceDate"
                            control={claimInsertionForm.control}
                            label={t("claimInsertion.claimInsertionRaInfo.form.label.invoiceDate")}
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IClaimInsertionForm>
                            name='claimInsertionRaInfo.segment'
                            control={claimInsertionForm.control}
                            label={t("claimInsertion.claimInsertionRaInfo.form.label.segment")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IClaimInsertionForm>
                            name='claimInsertionRaInfo.category'
                            control={claimInsertionForm.control}
                            label={t("claimInsertion.claimInsertionRaInfo.form.label.category")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IClaimInsertionForm>
                            name='claimInsertionRaInfo.product'
                            control={claimInsertionForm.control}
                            label={t("claimInsertion.claimInsertionRaInfo.form.label.product")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IClaimInsertionForm>
                            name='claimInsertionRaInfo.customerCode'
                            control={claimInsertionForm.control}
                            label={t("claimInsertion.claimInsertionRaInfo.form.label.customerCode")}
                            fullWidth
                            disabled
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default ClaimInsertionRaInfo;